var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"has-text-centered"},[_c('b',[_vm._v(_vm._s(_vm.$t("lockerDelivery.status"))+":")]),_vm._v("\n  "+_vm._s(_vm.status === "waitingPackage"
      ? _vm.$t("lockerDelivery.waitingPackage")
      : _vm.status === "accessedByCourier"
      ? _vm.$t("lockerDelivery.accessedByCourier")
      : _vm.status === "deliveryConfirmed"
      ? _vm.$t("lockerDelivery.deliveryConfirmed")
      : _vm.status === "waitingPickUp"
      ? _vm.$t("lockerDelivery.waitingPickUp")
      : _vm.status === "accessedByClient"
      ? _vm.$t("lockerDelivery.accessedByClient")
      : _vm.status === "pickupConfirmed"
      ? _vm.$t("lockerDelivery.pickupConfirmed")
      : _vm.status === "cancelled"
      ? _vm.$t("lockerDelivery.cancelled")
      : "-")+"\n  "),_c('br'),_c('b',[_vm._v(_vm._s(_vm.$t("lockerDelivery.observations"))+":")]),_vm._v("\n  "+_vm._s(_vm.observations ? _vm.observations : "-")+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }